export default __webpack_public_path__ + "static/media/output-onlinegiftools.6d282634.gif";